<template>
    <div class="widget" v-bind:class="widthClass">
        <div class="card">
            <div v-if="title" class="card-header">
                <slot name="title"></slot>
            </div>
            <div class="card-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props : {
        title: {
            type: Boolean,
            required: false,
            default: true
        },
        type: String,
        width: String, // full, 1/2, 1/3, 1/4
    },

    data() {
        return {};
    },

    computed: {
        widthClass() {
            switch (this.width) {
                case 'full':
                    return 'col-sm-12';
                    break;
                case '1/2':
                    return 'col-sm-6';
                    break;
                case '1/3':
                    return 'col-sm-4';
                    break;
                case '1/4':
                    return 'col-sm-3';
                    break;
            }

            return 'col-sm-12';
        }
    }
}
</script>
